import { Entity } from '@api/api/entity-schema';
import { Button } from '@design/components/button/Button';
import { Drawer } from '@design/components/drawer/Drawer';
import { DrawerContentWrapper } from '@terminal/components/drawer-content-wrapper/DrawerContentWrapper';
import { WebOnlyFeat } from '@terminal/config/WebOnlyFeat';
import { useNavigateToThemeOverview } from '@terminal/hooks/use-navigate-to-theme-overview/useNavigateToThemeOverview';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useTranslation } from 'react-i18next';

import { ThemeWidget } from '../ThemeWidget';
import { useThemeDrawer } from './useThemeDrawer';

export const DRAWER_THEME_ID = 'theme';

export interface ThemeDrawerProps {
  entity: Entity;
}

export const ThemeDrawer = ({ entity }: ThemeDrawerProps) => {
  const { t } = useTranslation(['widget']);
  const { navigateToTheme } = useNavigateToThemeOverview();

  const { closeDrawer, isDrawerOpen, themeId } = useThemeDrawer();

  if (!themeId) {
    return null;
  }

  return (
    <Drawer
      data-testid="theme-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        <WebOnlyFeat>
          <Button
            variant="empty"
            label={t('widget:themeOverview.drawer.themeOverview')}
            iconName="Expand"
            onClick={() =>
              navigateToTheme({
                themeId,
                source: POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW_DRAWER,
              })
            }
          />
        </WebOnlyFeat>
      }
    >
      <DrawerContentWrapper>
        <ThemeWidget entity={entity} themeId={themeId} />
      </DrawerContentWrapper>
    </Drawer>
  );
};
